var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:[
    'placeholder:text-muted-foreground border-input h-9 min-w-0 rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm outline-none disabled:opacity-50',
    'focus:border-ring focus:ring-2 focus:ring-ring',
    'w-full',
    _vm.className ],attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }